import { Injectable } from '@angular/core';
import { HttpRequest } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';

interface OngoingRequestObject {
    requests: { [key: string]: number };
    requestsWithoutBase: { [key: string]: number };
    currentlyOngoingRequests: string[];
    currentlyOngoingRequestsWithoutBase: string[];
    totalOngoingRequests: number;
}

@Injectable({
    providedIn: 'root',
})
export class OngoingRequestsService {
    private ongoingRequests: Subject<OngoingRequestObject> = new Subject();

    private requests: { [key: string]: number } = {};
    private requestsWithoutBase: { [key: string]: number } = {};
    private currentlyOngoingRequests: string[] = [];
    private currentlyOngoingRequestsWithoutBase: string[] = [];
    private totalOngoingRequests: number = 0;

    constructor() {}

    public getOngoingRequests(): Observable<OngoingRequestObject> {
        return this.ongoingRequests.asObservable();
    }

    public addRequest(request: HttpRequest<unknown>) {
        OngoingRequestsService.addToRequests(this.requests, request.url);
        OngoingRequestsService.addToRequests(this.requestsWithoutBase, request.url.substring(environment.BASE_URL.length));

        this.totalOngoingRequests++;
        this.recomputeOngoingRequests();
        this.sendOngoingRequestData();
    }

    public removeRequest(request: HttpRequest<unknown>) {
        OngoingRequestsService.removeFromRequests(this.requests, request.url);
        OngoingRequestsService.removeFromRequests(this.requestsWithoutBase, request.url.substring(environment.BASE_URL.length));

        this.totalOngoingRequests--;
        this.recomputeOngoingRequests();
        this.sendOngoingRequestData();
    }

    public recomputeOngoingRequests(): void {
        this.currentlyOngoingRequests = Object.keys(this.requests);
        this.currentlyOngoingRequestsWithoutBase = Object.keys(this.requestsWithoutBase);
    }

    private sendOngoingRequestData(): void {
        this.ongoingRequests.next({
            requests: this.requests,
            requestsWithoutBase: this.requestsWithoutBase,
            currentlyOngoingRequests: this.currentlyOngoingRequests,
            currentlyOngoingRequestsWithoutBase: this.currentlyOngoingRequestsWithoutBase,
            totalOngoingRequests: this.totalOngoingRequests,
        });
    }

    private static addToRequests(requestObject: { [key: string]: number }, requestUrl: string): void {
        if (!requestObject[requestUrl]) {
            requestObject[requestUrl] = 1;
        } else {
            requestObject[requestUrl]++;
        }
    }

    private static removeFromRequests(requestObject: { [key: string]: number }, requestUrl: string): void {
        if (requestObject[requestUrl] === 1) {
            delete requestObject[requestUrl];
        } else {
            requestObject[requestUrl]--;
        }
    }
}
